import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { reduxForm, getFormValues, Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { createMaintenanceTime, updateMaintenanceTime } from 'ducks/system'

const MaintenanceTimeModal = (props) => {
  const { valueForm, setShowModal } = props

  return (
    <Dialog open={true} className='dialog-full-height' maxWidth='lg' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Maintenance Time</DialogTitle>
      <DialogContent>
        <form>
          <Field name='message' label='Message' type={type.textArea} component={FieldInput} />
          <div style={{ display: 'flex' }}>
            <Field name='startTime' label='Start Time' type={type.dateTime} component={FieldInput} />
            <Field name='endTime' label='End Time' type={type.dateTime} component={FieldInput} />
          </div>
          <Field name='buyer' label='Active on DTGO' type={type.checkbox} component={FieldInput} />
          <Field name='seller' label='Active on Vendor' type={type.checkbox} component={FieldInput} />
        </form>
      </DialogContent>
      <DialogActions>
        {
          valueForm.id ? 
            <Button
              type='button'
              content='Save'
              color='blue'
              icon='save'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => props.updateMaintenanceTime(valueForm, () => setShowModal(false)) }
            /> : 
            <Button
              type='button'
              content='Create'
              color='blue'
              icon='paper plane outline'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => props.createMaintenanceTime(valueForm, () => setShowModal(false))}
            />
        }
        <Button
          type='button'
          content='Cancel'
          color='red'
          icon='times'
          labelPosition='right'
          style={{ marginRight: '5px' }}
          onClick={() => setShowModal(false)}
        />
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const { data } = props
  const editData = data || {}
  const valueForm = getFormValues('maintenanceTimeForm')(state) || {}
  
  return ({
    initialValues: {
      id: editData.id,
      message: editData.message,
      startTime: editData.startTime,
      endTime: editData.endTime,
      buyer: editData.buyer,
      seller: editData.seller
    },
    valueForm: valueForm
  })
}

const mapDispatchToProps = {
  createMaintenanceTime,
  updateMaintenanceTime
}

const MaintenanceTimeForm = reduxForm({
  form: 'maintenanceTimeForm',
  enableReinitialize: true,
})(MaintenanceTimeModal)

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceTimeForm)